import React from 'react';
import { useSelector } from 'react-redux';
import SliderShowContainer from 'ugc/components/ugcGallery/sliderShow/SliderShowContainer';
import useGetGalleryMediaList from 'ugc/hooks/useGetGalleryMediaList';
import Loading from 'client/components/Loading';
import { useHeightResizePostMessage } from 'client/hooks/useHeightResizePostMessage';

export default function WrapperSliderShow({ data }) {
    const { promoIdOfUgcLink: promoId, uuid: promoUUID } = useSelector(s => s.promo);
    const buttonClickLink = `/ugc/${promoId}${window.location.search}${window.location.hash}`;
    const clientBodyRef = useHeightResizePostMessage({ useMaxSize: true });
    const { galleryMediaList, isInit } = useGetGalleryMediaList(promoUUID);
    const sliderShow = transformSliderShow(galleryMediaList);

    function transformSliderShow(mediaList) {
        const media = mediaList.map(media => ({
            uuid: media.serialNo,
            value: media.value
        }));
        return media;
    }

    function handleClick(frameUuid) {
        if (frameUuid) {
            window.open(
                `/ugc/${promoId}/${frameUuid}${window.location.search}${window.location.hash}`
            );
        }
    }

    return (
        <>
            {!isInit && <Loading />}
            {sliderShow.length > 0 && (
                <SliderShowContainer
                    config={data.settingGame.galleryGameSetting}
                    clientBodyRef={clientBodyRef}
                    data={sliderShow}
                    buttonLink={buttonClickLink}
                    handleClick={handleClick}
                    needHandleClick
                    isInit={isInit}
                />
            )}
        </>
    );
}
